(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["temperos-intro"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('temperos-intro')) {
  customElements.define('temperos-intro', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const entryURL = new URL(window.location.href);
      customElements.whenDefined('variant-selects').then(() => {
        if (!this.isConnected) return;
        this.picker = this.closest('.shopify-section')?.querySelector('variant-selects');
        if (!this.picker) return;
        this.originalURLUpdate = this.picker.updateURL;
        this.picker.updateURL = () => {
          if (!this.picker.currentVariant || this.picker.dataset.updateUrl === 'false') return;
          const url = new URL(window.location.href);
          for (const [key, value] of entryURL.searchParams) {
            if (key !== 'variant' && !url.searchParams.has(key)) url.searchParams.set(key, value);
          }
          url.searchParams.set('variant', this.picker.currentVariant.id);
          window.history.replaceState(window.history.state, '', url);
        };
      });
    }
    disconnectedCallback() {
      if (this.picker && this.originalURLUpdate) this.picker.updateURL = this.originalURLUpdate;
      this.ready = false;
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["temperos-selection"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('temperos-selection')) {
  customElements.define('temperos-selection', class extends HTMLElement {
    connectedCallback() {
      if(this.ready)return;
      this.ready=true;
      this.variants=JSON.parse(this.querySelector('[data-tp-variants]').textContent);
      this.scope=this.closest('.shopify-section');
      this.entryURL=new URL(window.location.href);
      this.picker=this.scope.querySelector('variant-selects');
      customElements.whenDefined('variant-selects').then(()=>{
        if(!this.isConnected || !this.picker)return;
        this.originalURLUpdate=this.picker.updateURL;
        this.picker.updateURL=()=>{
          if(!this.picker.currentVariant || this.picker.dataset.updateUrl==='false')return;
          const url=new URL(window.location.href);
          for(const [key,value] of this.entryURL.searchParams){
            if(key!=='variant' && !url.searchParams.has(key))url.searchParams.set(key,value);
          }
          url.searchParams.set('variant',this.picker.currentVariant.id);
          window.history.replaceState(window.history.state,'',url);
        };
      });
      this.update=(event)=>{
        const picker=this.scope.querySelector('variant-selects');
        let variant;
        if(event?.target?.name==='id') variant=this.variants.find(item=>String(item.id)===event.target.value);
        if(!variant && picker){
          const groups=[...picker.querySelectorAll('.product-form__input')];
          const options=groups.map(group=>group.querySelector('input:checked,select')?.value);
          variant=this.variants.find(item=>item.options.every((option,index)=>option===options[index]));
        }
        if(!variant){
          const input=this.scope.querySelector('form[action*="/cart/add"] [name="id"]');
          variant=this.variants.find(item=>String(item.id)===String(input?.value||this.dataset.initial));
        }
        if(!variant)return;
        const kit=(variant.option2||'').toLowerCase();
        this.querySelector('[data-tp-format]').textContent=variant.option1;
        this.querySelector('[data-tp-contents]').textContent=kit.includes('base')?this.dataset.complete:kit.includes('6')?this.dataset.six:this.dataset.twelve;
      };
      this.scope.addEventListener('change',this.update);
      this.update();
    }
    disconnectedCallback(){this.scope?.removeEventListener('change',this.update);if(this.picker && this.originalURLUpdate)this.picker.updateURL=this.originalURLUpdate;this.ready=false;}
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["vitaalu-147-cro"] && !Shopify.designMode) return;
  try {
    function vitaAlu147Totals(){const marker=document.querySelector('.va147-cro');if(!marker)return;const main=marker.closest('.shopify-section');const data=main.querySelector('[data-va147-variants]');const total=main.querySelector('[data-va147-total]');if(!data||!total)return;let variants;try{variants=JSON.parse(data.textContent);}catch{return;}const money=new Intl.NumberFormat('pt-BR',{style:'currency',currency:document.documentElement.dataset.currency||'BRL'});const update=()=>{const picker=main.querySelector('variant-selects');const input=main.querySelector('.main-quantity input[name="quantity"]');const quantity=Math.max(1,parseInt(input?.value,10)||1);const id=picker?.currentVariant?.id||main.querySelector('product-form input[name="id"]')?.value;const variant=variants.find(v=>String(v.id)===String(id));if(quantity<=1||!variant||!Number.isFinite(variant.price)){total.hidden=true;total.textContent='';return;}let units=0;if(variant.option1==='2un + 4 Adesivos ProFix')units=2;if(variant.option1==='4un + 8 Adesivos ProFix + Brinde')units=4;total.textContent=quantity+' kits'+(units?' · '+quantity*units+' prateleiras':'')+' · Total '+money.format(quantity*variant.price/100);total.hidden=false;};document.addEventListener('input',update);document.addEventListener('change',update);document.addEventListener('click',()=>setTimeout(update,500));main.addEventListener('reset',()=>setTimeout(update,0));const drawer=document.querySelector('cart-drawer');if(drawer)new MutationObserver(update).observe(drawer,{attributes:true,childList:true,subtree:true});update();}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',vitaAlu147Totals,{once:true});else vitaAlu147Totals();

function vitaAlu147KeepQuery(){const marker=document.querySelector('.va147-cro');if(!marker)return;const entryURL=new URL(window.location.href);customElements.whenDefined('variant-selects').then(()=>{const picker=marker.closest('.shopify-section')?.querySelector('variant-selects');if(!picker)return;picker.updateURL=()=>{if(!picker.currentVariant||picker.dataset.updateUrl==='false')return;const url=new URL(window.location.href);for(const[key,value]of entryURL.searchParams){if(key!=='variant'&&!url.searchParams.has(key))url.searchParams.set(key,value);}url.searchParams.set('variant',picker.currentVariant.id);window.history.replaceState(window.history.state,'',url);};});}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',vitaAlu147KeepQuery,{once:true});else vitaAlu147KeepQuery();

function vitaAlu147ClearMain(){const marker=document.querySelector('.va147-cro');const main=marker?.closest('.shopify-section');if(!main)return;new IntersectionObserver(entries=>document.body.classList.toggle('va147-main-visible',entries[0].isIntersecting)).observe(main);}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',vitaAlu147ClearMain,{once:true});else vitaAlu147ClearMain();
function vitaAlu147ColorLabel(){const marker=document.querySelector('.va147-b:not(.va147-c)');const main=marker?.closest('.shopify-section');if(!main)return;const update=()=>{main.querySelectorAll('input[name="Cor"]').forEach(input=>{if(input.value!=='Preto com borda dourada')return;const label=input.nextElementSibling;if(label?.tagName!=='LABEL')return;for(const node of label.childNodes){if(node.nodeType===Node.TEXT_NODE&&node.nodeValue.includes('Preto com borda dourada'))node.nodeValue=node.nodeValue.replace('Preto com borda dourada','Preto com dourado');}});};update();new MutationObserver(update).observe(main,{childList:true,subtree:true});}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',vitaAlu147ColorLabel,{once:true});else vitaAlu147ColorLabel();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["vitaalu-cro-styles"] && !Shopify.designMode) return;
  try {
    function vitaAluCroClearMain() {
 const marker=document.querySelector('.va-cro');
 const main=marker?.closest('.shopify-section');
 if(!main) return;
 const observer=new IntersectionObserver(entries=>document.body.classList.toggle('va-main-visible',entries[0].isIntersecting));
 observer.observe(main);
}
if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',vitaAluCroClearMain,{once:true}); else vitaAluCroClearMain();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["vitaalu-hero"] && !Shopify.designMode) return;
  try {
    function vitaAluAddWeekdays(date, days) {
  const result = new Date(date);
  let added = 0;
  while (added < days) {
    result.setUTCDate(result.getUTCDate() + 1);
    if (result.getUTCDay() !== 0 && result.getUTCDay() !== 6) added++;
  }
  return result;
}
function vitaAluDeliveryDates() {
  const parts = new Intl.DateTimeFormat('en-US', {timeZone:'America/Sao_Paulo', year:'numeric', month:'2-digit', day:'2-digit'}).formatToParts(new Date());
  const part = type => parts.find(item => item.type === type).value;
  const today = new Date(Date.UTC(Number(part('year')), Number(part('month')) - 1, Number(part('day')), 12));
  const format = new Intl.DateTimeFormat('pt-BR', {timeZone:'UTC', day:'numeric', month:'long'});
  document.querySelectorAll('[data-va-delivery]').forEach(block => {
    if (!block.querySelector('[data-va-date-start]') || !block.querySelector('[data-va-date-end]') || !block.querySelector('[data-va-date-fallback]') || !block.querySelector('[data-va-date-range]')) return;
    const start = vitaAluAddWeekdays(today, Number(block.dataset.minDays));
    const end = vitaAluAddWeekdays(today, Number(block.dataset.maxDays));
    const startNode = block.querySelector('[data-va-date-start]');
    const endNode = block.querySelector('[data-va-date-end]');
    startNode.textContent = start.getUTCMonth() === end.getUTCMonth() && start.getUTCFullYear() === end.getUTCFullYear() ? String(start.getUTCDate()) : format.format(start);
    endNode.textContent = format.format(end);
    startNode.dateTime = start.toISOString().slice(0,10);
    endNode.dateTime = end.toISOString().slice(0,10);
    block.querySelector('[data-va-date-fallback]').hidden = true;
    block.querySelector('[data-va-date-range]').hidden = false;
  });
}
function vitaAluInitDelivery() {
  vitaAluDeliveryDates();
  // Theme-editor previews can insert or replace section markup after page load.
  const observer = new MutationObserver(records => {
    const hasDeliveryMarkup = records.some(record => [...record.addedNodes].some(node =>
      node.nodeType === 1 && (node.matches('[data-va-delivery]') || node.querySelector('[data-va-delivery]'))
    ));
    if (hasDeliveryMarkup) vitaAluDeliveryDates();
  });
  observer.observe(document.body, {childList:true, subtree:true});
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', vitaAluInitDelivery, {once:true});
else vitaAluInitDelivery();
document.addEventListener('shopify:section:load', vitaAluDeliveryDates);
let vitaAluBuyObserver;
function vitaAluKeepBuyClear() {
  if (vitaAluBuyObserver) vitaAluBuyObserver.disconnect();
  document.body.classList.remove('va-buy-visible');
  const intro = document.querySelector('.va-intro');
  const main = intro && intro.closest('section[id^="MainProduct-"]');
  const button = main && main.querySelector('[id^="ProductSubmitButton-"]');
  if (!button) return;
  vitaAluBuyObserver = new IntersectionObserver(entries => {
    document.body.classList.toggle('va-buy-visible', entries[0].isIntersecting);
  }, {rootMargin:'12px',threshold:0});
  vitaAluBuyObserver.observe(button);
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', vitaAluKeepBuyClear);
else vitaAluKeepBuyClear();
document.addEventListener('shopify:section:load', vitaAluKeepBuyClear);
  } catch(e) { console.error(e); }
})();

})();
